import React, { useEffect, useState, useRef } from "react";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import {
  Card,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Button,
  Container,
  Stack,
  Checkbox,
  CardContent,
  Typography,
  CardActions,
} from "@material-ui/core";
import { motion } from "framer-motion";
import { experimentalStyled as styled } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/styles";
import LoadingButton from "@material-ui/lab/LoadingButton";
import Label from "../Label";

import { dbx } from "../../utils/urlBack_End";
import IconButton from "@material-ui/core/IconButton";
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";
import { faEdit } from "@fortawesome/free-solid-svg-icons/faEdit";
import { faPlay } from "@fortawesome/free-solid-svg-icons/faPlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { sentenceCase } from "change-case";

import ModifyTaskStateModal from "../_dashboard/tareas/ModifyTaskStateModal";

import RemoveIcon from "@material-ui/icons/Cancel";
import AgregarSubTareaDialog from "./AgregarSubTareaDialog";
import ArchivoSubtareaDialog from "./ArchivoSubtareaDialog";
import EditarSubTareaDialog from "./EditarSubTareaDialog";
import HistorialTiempoSubTareaDialog from "./HistorialTiempoSubTareaDialog";
import { AlertaMensajeEliminacion } from "../AlertaMensajeEliminacion";
import moment from "moment";
import { useStopwatch } from "react-timer-hook";
import { MotionContainer, varBounceIn } from "../animate";
import { subtareasApi } from "src/services/subtareasApi";
import { AlertaModalV2 } from "../AlertaSwall";
import { useSnackbar } from "src/components/snackbar";
import { TablaHead } from "src/components/_dashboard/tablas";
import BarraSeleccionSubtareas from "./BarraSeleccionSubtareas";
import useSeleccionSubtareas from "./hooks/useSeleccionSubtareas";

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "nombre", label: "Nombre", alignRight: false },
  { id: "fechaInicio", label: "Fecha Inicio", alignRight: false },
  { id: "fechaTermino", label: "Fecha Término", alignRight: false },
  { id: "archivo", label: "Archivo", alignRight: false },
  {
    id: "mostrarArchivo",
    label: "Mostrar Archivo al Cliente",
    alignRight: false,
  },
  { id: "estado", label: "Estado", alignRight: false },
  { id: "tiempo", label: "Tiempo", alignRight: false },
  { id: "acciones", label: "Acciones", alignRight: false },
];

const RootStyle = styled("div")(({ theme }) => ({
  marginTop: "1rem",
}));

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    // Nueve columnas no caben en el ancho del detalle: sin esto los encabezados y el
    // contenido de las celdas se parten en varias líneas. Se deja que la tabla crezca y
    // el TableContainer haga scroll horizontal.
    "& th, & td": {
      whiteSpace: "nowrap",
    },
  },
  hidden: {
    display: "none",
  },
});

// ----------------------------------------------------------------------

export default function Subtareas({ tarea }) {
  const { data: subtareas = [], isLoading: isLoadingSubtareas } =
    subtareasApi.useGetSubtareasTareaQuery(tarea.id);

  const [crearNuevoTiempo] = subtareasApi.useAddCrearNuevoTiempoMutation();
  const [actualizarEstadoSubtarea] =
    subtareasApi.useUpdateEstadoSubtareaMutation();
  const [eliminarArchivo] = subtareasApi.useDeleteArchivoMutation();
  const [actualizarMostrarArchivo] =
    subtareasApi.useUpdateMostrarArchivoMutation();
  const [eliminarSubtarea] = subtareasApi.useDeleteSubtareaMutation();

  const {
    subTareasSeleccionadas,
    puedeSeleccionar,
    subtareasSeleccionables,
    puedeModificarSubtarea,
    headLabel,
    handleSelectAllClick,
    estaSeleccionada,
    alternarSeleccion,
    handleDeleteLista,
  } = useSeleccionSubtareas({ tarea, subtareas, columnas: TABLE_HEAD });

  const classes = useStyles();
  const [showModifyTaskState, setShowModifyTaskState] = useState(false);
  const [selectedTask, setSelectedTask] = useState();

  const [loadingEliminar, setLoadingEliminar] = useState(false);
  const [subTareaSeleccionada, setSubTareaSeleccionada] = useState(null);

  const [mostrarDialogArchivo, setMostrarDialogArchivo] = useState(false);

  const [mostrarAgregar, setMostrarAgregar] = useState(false);
  const [mostrarHistorialTiempo, setMostrarHistorialTiempo] = useState(false);
  const [mostrarEliminarArchivoSubTarea, setMostrarEliminarArchivoSubTarea] =
    useState(false);

  const [selectedSubTaskEdit, setSelectedSubTaskEdit] = useState(null);
  const [selectSubTaskFileDelete, setSelectSubTaskFileDelete] = useState(null);
  const [selectSubTaskCronometro, setSelectSubTaskCronometro] = useState(null);
  const [mostrarEditar, setMostrarEditar] = useState(false);
  const [eliminarLista, setEliminarLista] = useState(false);
  const isMounted = useRef(true);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleChangeTaskState = (id) => {
    const selectedTaskAux = subtareas.find((t) => t.id === id);
    setSelectedTask(selectedTaskAux);
    setShowModifyTaskState(true);
  };

  const doChangeTaskState = (newState) => {
    if (selectedTask.estado === newState) return setShowModifyTaskState(false);
    actualizarEstadoSubtarea({
      id: selectedTask.id,
      body: {
        estado: newState,
      },
    })
      .unwrap()
      .then(() => {
        enqueueSnackbar("Subtarea actualizada", {
          variant: "success",
        });
      })
      .catch(() => {
        enqueueSnackbar("Error en el servidor", {
          variant: "error",
        });
      });
    setShowModifyTaskState(false);
  };

  const handleDelete = (id) => {
    AlertaModalV2({
      title: "¿Quiere eliminar la subtarea?",
      text: "La subtarea sera eliminada, ¿Está seguro?",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      icon: "warning",
    })
      .fire()
      .then((result) => {
        if (result.isConfirmed) {
          eliminarSubtarea(id)
            .unwrap()
            .then(() => {
              enqueueSnackbar("Subtarea eliminada", {
                variant: "success",
              });
            })
            .catch((error) => {
              // Mismo motivo que en el lote: DELETE /subtareas/:id devuelve 403, 404 y 409
              // con su mensaje, y el genérico los tapaba.
              enqueueSnackbar(error?.data?.message || "Error en el servidor", {
                variant: "error",
              });
            });
        }
      });
  };

  const removeFile = async (subTarea) => {
    setLoadingEliminar(true);
    if (
      subTarea &&
      subTarea.id &&
      subTarea.nombreArchivo &&
      subTarea.refTarea
    ) {
      try {
        await deleteFileFromDropbox(subTarea.nombreArchivo, subTarea.refTarea);
        deleteFileFromDB(subTarea.id);
      } catch (ex) {
      } finally {
        setLoadingEliminar(false);
      }
    } else {
      setLoadingEliminar(false);
    }
  };

  const deleteFileFromDB = (idSubTarea) => {
    eliminarArchivo(idSubTarea)
      .unwrap()
      .then(() => {
        enqueueSnackbar("Archivo eliminado", {
          variant: "success",
        });
      })
      .catch(() => {
        enqueueSnackbar("Error en el servidor", {
          variant: "error",
        });
      });
  };

  const deleteFileFromDropbox = (nombre, refTarea) => {
    return dbx.filesDeleteV2({
      path: `/Tareas/${refTarea}/SubTareas/${nombre}`,
    });
  };

  function secondsToString(seconds) {
    var hour = Math.floor(seconds / 3600);
    hour = hour < 10 ? "0" + hour : hour;
    var minute = Math.floor((seconds / 60) % 60);
    minute = minute < 10 ? "0" + minute : minute;
    var second = seconds % 60;
    second = second < 10 ? "0" + second : second;
    return hour + ":" + minute + ":" + Math.round(second);
  }

  const { seconds, minutes, hours, isRunning, start, pause, reset } =
    useStopwatch({ autoStart: false });

  return (
    <Container>
      <RootStyle>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Button
            disabled={
              tarea.estado &&
              (tarea.estado === "TERMINADA" ||
                tarea.estado === "FACTURADO" ||
                tarea.estado === "PENDIENTE DE FACTURACION")
            }
            variant="contained"
            startIcon={<Icon icon={plusFill} />}
            onClick={() => {
              setMostrarAgregar(true);
            }}
          >
            Agregar SubTarea
          </Button>
        </Stack>

        {selectSubTaskCronometro && (
          <MotionContainer initial="initial" open>
            <Card>
              <CardContent
                style={{
                  textAlign: "center",
                }}
              >
                <Stack>
                  <motion.div variants={varBounceIn}>
                    <Typography variant="h5" color="primary">
                      {`En proceso: ${selectSubTaskCronometro.nombre}`}
                    </Typography>
                  </motion.div>
                  <motion.div variants={varBounceIn}>
                    <Typography variant="h2" color="primary">
                      {`${hours}:${minutes}:${seconds}`}
                    </Typography>
                  </motion.div>
                </Stack>
              </CardContent>
              <CardActions>
                {isRunning === false ? (
                  <Button
                    style={{ marginTop: "20px" }}
                    size="large"
                    variant="contained"
                    onClick={start}
                  >
                    Iniciar
                  </Button>
                ) : (
                  <>
                    <Button
                      style={{ marginTop: "20px" }}
                      size="large"
                      color="error"
                      variant="contained"
                      onClick={pause}
                    >
                      Detener
                    </Button>
                    <Button
                      style={{ marginTop: "20px" }}
                      size="large"
                      color="info"
                      variant="contained"
                      onClick={() => {
                        pause();
                        let segundosFinal = 0;
                        if (hours > 0) {
                          segundosFinal = Math.round(
                            Number(`${minutes}.${seconds}`) * 3600,
                          );
                        } else if (minutes > 0) {
                          segundosFinal = Math.round(
                            Number(`${minutes}.${seconds}`) * 60,
                          );
                        } else {
                          segundosFinal = seconds;
                        }
                        crearNuevoTiempo({
                          refIdSubTarea: selectSubTaskCronometro.id,
                          segundos: segundosFinal,
                        })
                          .unwrap()
                          .then(() => {
                            reset(null, false);
                            enqueueSnackbar("Nuevo tiempo agregado", {
                              variant: "success",
                            });
                          })
                          .catch(() => {
                            enqueueSnackbar("Error en el servidor", {
                              variant: "error",
                            });
                          })
                          .finally(() => {
                            setSelectSubTaskCronometro(null);
                          });
                      }}
                    >
                      Finalizar
                    </Button>
                  </>
                )}
              </CardActions>
            </Card>
          </MotionContainer>
        )}

        <Card style={{ padding: "1rem" }}>
          {puedeSeleccionar && (
            <BarraSeleccionSubtareas
              cantidad={subTareasSeleccionadas.length}
              onEliminar={handleDeleteLista}
            />
          )}

          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TablaHead
                headLabel={headLabel}
                // La tabla no ordena: el encabezado compartido siempre llama a este
                // handler al hacer clic en una columna, así que se le da uno vacío.
                onRequestSort={() => {}}
                select={puedeSeleccionar}
                rowCount={subtareasSeleccionables.length}
                selectedRows={subTareasSeleccionadas}
                handleSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {!isLoadingSubtareas &&
                  subtareas.map((row, idx) => {
                    const totalTiempo = Array.isArray(row.horasDedicadas)
                      ? row.horasDedicadas.reduce(
                          (acc, item) => acc + (item?.segundos || 0),
                          0,
                        )
                      : 0;
                    return (
                      <TableRow key={idx}>
                        {/* Sin casilla cuando la tarea está cerrada o cuando la subtarea
                            ya está terminada, que tampoco se puede eliminar. La celda se
                            pinta igual para no descuadrar las columnas. */}
                        {!puedeModificarSubtarea(row) ? (
                          <TableCell></TableCell>
                        ) : (
                          <TableCell>
                            <Checkbox
                              checked={estaSeleccionada(row)}
                              onChange={(event) =>
                                alternarSeleccion(row, event.target.checked)
                              }
                            />
                          </TableCell>
                        )}

                        <TableCell component="th" scope="row">
                          {row.nombre}
                        </TableCell>
                        <TableCell>
                          {row.fechaInicio === ""
                            ? row.fechaInicio
                            : moment(row.fechaInicio, "YYYY/MM/DD").format(
                                "DD/MM/YYYY",
                              )}
                        </TableCell>
                        <TableCell>
                          {row.fechaTermino === ""
                            ? row.fechaTermino
                            : moment(row.fechaTermino, "YYYY/MM/DD").format(
                                "DD/MM/YYYY",
                              )}
                        </TableCell>
                        <TableCell>
                          {row.urlArchivo ? (
                            // El enlace y el botón de quitar van en la misma línea: con
                            // Grid item xs anidado en un div quedaban uno bajo el otro.
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <a
                                href={row.urlArchivo}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Visualizar
                              </a>
                              {tarea.estado &&
                              (tarea.estado === "TERMINADA" ||
                                tarea.estado === "FACTURADO" ||
                                tarea.estado === "PENDIENTE DE FACTURACION") ? (
                                <></>
                              ) : (
                                <LoadingButton
                                  loading={loadingEliminar}
                                  color="error"
                                  onClick={() => {
                                    setSelectSubTaskFileDelete(row);
                                    setMostrarEliminarArchivoSubTarea(true);
                                  }}
                                >
                                  <RemoveIcon />
                                </LoadingButton>
                              )}
                            </Stack>
                          ) : (
                            <Button
                              disabled={
                                tarea.estado &&
                                (tarea.estado === "TERMINADA" ||
                                  tarea.estado === "FACTURADO" ||
                                  tarea.estado === "PENDIENTE DE FACTURACION")
                              }
                              variant="contained"
                              onClick={() => {
                                setSubTareaSeleccionada(row);
                                setMostrarDialogArchivo(true);
                              }}
                            >
                              Subir Archivo
                            </Button>
                          )}
                        </TableCell>
                        <TableCell>
                          <Checkbox
                            checked={row.mostrarArchivo === "NO" ? false : true}
                            onChange={(event) => {
                              let mostrarArchivo = "NO";
                              if (event.target.checked) {
                                mostrarArchivo = "SI";
                              }
                              actualizarMostrarArchivo({
                                mostrarArchivo: mostrarArchivo,
                                idSubtarea: row.id,
                              })
                                .unwrap()
                                .then(() => {
                                  enqueueSnackbar(
                                    "Mostrar archivo actualizado",
                                    {
                                      variant: "success",
                                    },
                                  );
                                })
                                .catch(() => {
                                  enqueueSnackbar("Error en el servidor", {
                                    variant: "error",
                                  });
                                });
                            }}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                        </TableCell>
                        <TableCell>
                          {tarea.estado &&
                          (tarea.estado === "TERMINADA" ||
                            tarea.estado === "FACTURADO" ||
                            tarea.estado === "PENDIENTE DE FACTURACION") ? (
                            <Label
                              variant="ghost"
                              color={
                                (row.estado === "PENDIENTE" && "error") ||
                                (row.estado === "EN PROCESO" && "warning") ||
                                (row.estado === "TERMINADA" && "success") ||
                                "info"
                              }
                            >
                              {sentenceCase(row.estado)}
                            </Label>
                          ) : (
                            <Label
                              onClick={() => handleChangeTaskState(row.id)}
                              style={{ cursor: "pointer" }}
                              variant="ghost"
                              color={
                                (row.estado === "PENDIENTE" && "error") ||
                                (row.estado === "EN PROCESO" && "warning") ||
                                (row.estado === "TERMINADA" && "success") ||
                                "info"
                              }
                            >
                              {sentenceCase(row.estado)}
                            </Label>
                          )}
                        </TableCell>
                        <TableCell>
                          <Stack direction="row" alignItems="center">
                            {tarea.estado &&
                            (tarea.estado === "TERMINADA" ||
                              tarea.estado === "FACTURADO" ||
                              tarea.estado === "PENDIENTE DE FACTURACION") ? (
                              <></>
                            ) : row.estado === "TERMINADA" ? (
                              <></>
                            ) : (
                              <Button
                                color="primary"
                                onClick={() => {
                                  setSelectSubTaskCronometro(row);
                                }}
                              >
                                <FontAwesomeIcon icon={faPlay} />
                              </Button>
                            )}

                            <Button
                              onClick={() => {
                                setSubTareaSeleccionada(row);
                                setMostrarHistorialTiempo(true);
                              }}
                            >
                              Tiempo Total: {secondsToString(totalTiempo)}
                            </Button>
                          </Stack>
                        </TableCell>
                        <TableCell>
                          {!puedeModificarSubtarea(row) ? (
                            <></>
                          ) : (
                            <React.Fragment>
                              <IconButton
                                color="primary"
                                onClick={() => {
                                  setSelectedSubTaskEdit(row);
                                  setMostrarEditar(true);
                                }}
                              >
                                <FontAwesomeIcon icon={faEdit} />
                              </IconButton>
                              <IconButton
                                color="error"
                                onClick={() => {
                                  handleDelete(row.id);
                                }}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </IconButton>
                            </React.Fragment>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>

            {selectedTask && (
              <ModifyTaskStateModal
                task={selectedTask}
                onSubmit={doChangeTaskState}
                onClose={() => setShowModifyTaskState(false)}
                states={[
                  "PENDIENTE",
                  "EN PROCESO",
                  "OBSERVADA SII",
                  "TERMINADA",
                ]}
                open={showModifyTaskState}
                cargandoDatos={false}
              />
            )}
          </TableContainer>
        </Card>
        {mostrarHistorialTiempo && (
          <HistorialTiempoSubTareaDialog
            open={mostrarHistorialTiempo}
            setOpen={setMostrarHistorialTiempo}
            subtarea={subTareaSeleccionada}
          />
        )}
        {mostrarAgregar && (
          <AgregarSubTareaDialog
            open={mostrarAgregar}
            setOpen={setMostrarAgregar}
            tarea={tarea}
          />
        )}

        {mostrarDialogArchivo && (
          <ArchivoSubtareaDialog
            open={mostrarDialogArchivo}
            setOpen={setMostrarDialogArchivo}
            subTarea={subTareaSeleccionada}
          />
        )}
        {mostrarEditar && (
          <EditarSubTareaDialog
            open={mostrarEditar}
            setOpen={setMostrarEditar}
            subTarea={selectedSubTaskEdit}
            tarea={tarea}
          />
        )}

        {mostrarEliminarArchivoSubTarea &&
          selectSubTaskFileDelete &&
          selectSubTaskFileDelete.id && (
            <AlertaMensajeEliminacion
              mensaje={"¿Seguro que deseas eliminar el archivo?"}
              open={mostrarEliminarArchivoSubTarea}
              setOpen={setMostrarEliminarArchivoSubTarea}
              aceptar={() => {
                removeFile(selectSubTaskFileDelete);
              }}
              mensajeBotonAceptar={"Eliminar"}
            />
          )}

        {eliminarLista && (
          <AlertaMensajeEliminacion
            mensaje={"¿Seguro que desea eliminar estas subtareas?"}
            open={eliminarLista}
            setOpen={setEliminarLista}
            aceptar={() => {
              subTareasSeleccionadas.map((subTarea) => removeFile(subTarea));
            }}
            mensajeBotonAceptar={"Eliminar"}
          />
        )}
      </RootStyle>
    </Container>
  );
}
